import React from 'react';
import PropTypes from 'prop-types';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';
import SlideshowRoundedIcon from '@mui/icons-material/SlideshowRounded';
import FolderZipRoundedIcon from '@mui/icons-material/FolderZipRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';

// An icon in the colour of the file's type, so a list of documents can be read at a glance.
const TYPES = [
    [/\.pdf$/i, PictureAsPdfRoundedIcon, '#d84b3e'],
    [/\.(png|jpe?g|gif|bmp|webp|heic)$/i, ImageRoundedIcon, '#2e9d6a'],
    [/\.(docx?|rtf|odt|txt)$/i, DescriptionRoundedIcon, '#2b5fb4'],
    [/\.(xlsx?|csv|ods)$/i, TableChartRoundedIcon, '#1f7a45'],
    [/\.(pptx?|odp)$/i, SlideshowRoundedIcon, '#c4602b'],
    [/\.zip$/i, FolderZipRoundedIcon, '#7a6a3a'],
];

const FileTypeIcon = ({name = '', sx}) => {
    const [, Icon, color] = TYPES.find(([pattern]) => pattern.test(name)) ?? [null, InsertDriveFileRoundedIcon, '#186BBE'];

    return <Icon sx={{color, ...sx}}/>;
};

FileTypeIcon.propTypes = {
    name: PropTypes.string,
    sx: PropTypes.object
};

export default FileTypeIcon;
